// extracted by mini-css-extract-plugin
export default {"input":"putiPage_input__7DRon","main":"putiPage_main__dLU5T","header":"putiPage_header__ubt7Q"};